
import React from "react";
import { C } from "../utils/api";

export default function Bottom({view, setView, averias}) {
  const items=[{id:"mapa",l:"Mapa"},{id:"equipos",l:"Equipos"},{id:"clientes",l:"Clientes"},{id:"averias",l:"Averias",b:averias.length}];
  return (
    <div style={{background:C.white,borderTop:"1px solid "+C.border,display:"flex",height:56,flexShrink:0}}>
      {items.map(item=>(
        <div key={item.id} onClick={()=>setView(item.id)} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",cursor:"pointer",color:view===item.id?C.accent:C.muted,fontSize:11,gap:2,position:"relative"}}>
          {item.l}
          {item.b>0 && <span style={{position:"absolute",top:4,right:"20%",background:"#EF4444",color:"#fff",borderRadius:99,fontSize:9,padding:"1px 4px"}}>{item.b}</span>}
        </div>
      ))}
    </div>
  );
}
